export class ReservePaymentsCheckedPostRequest {
  billingMonth!: string
  isConfirmed!: boolean
}
